/**
 * Dependencies
 */
import Vue from 'vue'
import http from '../../../services/HttpService'

/**
 * Upload a CSV file to the rent roll importer
 *
 * @param  {Function} options.commit
 * @param  {FormData} data
 * @return {Promise}
 */
const uploadFile = ({ commit }, data) => {
    let formData = new FormData()
    formData.append('file', data.file)
    if (data.excel_sheet !== null) {
        formData.append('excel_sheet', data.excel_sheet)
    }

    commit('BEGIN_UPLOAD')

    http.post(`projects/rentroll-importer/`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: function (progressEvent) {
            let progress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            commit('UPDATE_UPLOAD_PROGRESS', progress)
        }
    })
    .then(res => {
        commit('SET_MAPPINGS', res.data)
        commit('projects/form/UPDATE_FILE_ID', {
            id: res.data.meta.rentroll_file_id,
            type: 'rentroll_file_id'
        }, { root: true })
    })
    .catch(e => commit('SET_MAPPINGS_ERROR', e))
}

/**
 * Update the user-confirmed bindings
 *
 * @param  {Function} options.commit
 * @param  {Object} options.state
 * @return {Void}
 */
const updateImporterBindings = ({ commit, state, dispatch }) => {
    commit('SAVING_BINDINGS')
    http.patch(`projects/rentroll-update/${state.meta.rentroll_file_id}/`, state.mapping)
        .then(res => {
            let data = res.data
            if (data.meta) {
                Vue.delete(data, 'meta')
            }
            dispatch('projects/form/updateUnitValues', data, { root: true })
                .then(() => commit('FILE_IMPORTED'))
                .catch(() => console.log('failed'))
        })
        .catch(err => commit('IMPORT_MAPPINGS_ERROR', err))
}

/**
 * Reset the state
 *
 * @param  {Function} commit
 * @return {Void}
 */
const resetState = ({ commit }) =>
    commit('RESET_STATE')

/**
 * Reset a given binding
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const resetBinding = ({ commit }, payload) =>
    commit('RESET_BINDING', payload)

/**
 * Set a given binding
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
const setBinding = ({ commit }, payload) =>
    commit('SET_BINDING', payload)

/**
 * Allow the user to request assistance with a file that fails to upload properly
 *
 * @param  {Function} options.commit
 * @param  {Number} id
 * @return {Promise}
 */
const requestFileAssistance = ({ commit, state }) => {
    commit('REQUEST_FILE_ASSISTANCE')
    http.post(`projects/import-file/${state.error.rentroll_file_id}/support/`)
        .then(res => commit('SUPPORT_REQUEST_SUCCESS', res))
        .catch(err => commit('SUPPORT_REQUEST_FAILURE', err))
}

export default {
    uploadFile,
    resetState,
    setBinding,
    resetBinding,
    requestFileAssistance,
    updateImporterBindings
}



// WEBPACK FOOTER //
// ./src/state/modules/rental-income-importer/actions.js